import { useState } from 'react'
import styled from 'styled-components'
import { ImageAsset } from '@/components/common'
import FlatIcon from '@/components/common/icons/FlatIcon'
import { Typo } from '@/components/common/typography'
import { GlobalColorEnum } from '@/constants/global-color.enum'
import { IconNameEnum } from '@/constants/icon-name.enum'
import { IconSizeEnum } from '@/constants/icon-size.enum'
import { currencyText } from '@/utils/utilNumber'

interface MileageBenefitSectionProps {
  isMembership: boolean
  /** 총 예상 최대 적립금 (expectedImageReviewMileage + expectedOrderConfirmedMileage) */
  expectedMileage: number
  /** 구매 확정 예상 적립금 */
  expectedOrderConfirmMileageForRegular: number
  /** 리뷰 작성 예상 적립금 */
  expectedImageReviewMileage: number
  /** 멤버십 추가 적립금  */
  expectedOrderConfirmMileageDifferenceBetweenMembershipAndRegular?: number
}

export const MileageBenefitSection = ({
  isMembership,
  expectedMileage,
  expectedOrderConfirmMileageForRegular,
  expectedImageReviewMileage,
  expectedOrderConfirmMileageDifferenceBetweenMembershipAndRegular,
}: MileageBenefitSectionProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(true)
  const handleToggle = () => {
    setIsOpen((prevState) => !prevState)
  }

  return (
    <>
      <StyledSectionTitle onClick={handleToggle}>
        <Typo variant="Body1 Bold">적립금 혜택</Typo>
        <StyledTotalMileage>
          <Typo variant="Body1 Bold">{currencyText(expectedMileage)}</Typo>
          <FlatIcon type={isOpen ? IconNameEnum.IcArrowUp : IconNameEnum.IcArrowDown} size={IconSizeEnum.Size24} />
        </StyledTotalMileage>
      </StyledSectionTitle>
      {isOpen && (
        <StyledMileageBenefitContent>
          <StyledMileageBenefitWrapper>
            <>
              <StyledMileageBenefitRow>
                <Typo variant="Body3 Regular">구매 확정 시 적립</Typo>
                <Typo variant="Body4 Regular">{`+${currencyText(expectedOrderConfirmMileageForRegular)}`}</Typo>
              </StyledMileageBenefitRow>
              {isMembership && (
                <StyledDd>
                  <StyledDdBefore>
                    <Typo variant="Body3 Regular">ㄴ</Typo>
                    <ImageAsset name="fitpet_plus_logo" folder="membership" size={70} height={20} svg rem />
                    <Typo variant="Body3 Regular">추가 적립</Typo>
                  </StyledDdBefore>
                  <Typo variant="Body4 Regular">{`+${currencyText(
                    expectedOrderConfirmMileageDifferenceBetweenMembershipAndRegular || 0
                  )}`}</Typo>
                </StyledDd>
              )}
            </>
            <StyledMileageBenefitRow>
              <Typo variant="Body3 Regular">리뷰 작성 시 적립</Typo>
              <Typo variant="Body4 Regular">{`+${currencyText(expectedImageReviewMileage)}`}</Typo>
            </StyledMileageBenefitRow>
          </StyledMileageBenefitWrapper>
        </StyledMileageBenefitContent>
      )}
    </>
  )
}

const StyledSectionTitle = styled.div`
  height: 4.8rem;
  padding: 1.2rem 1.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${GlobalColorEnum.Gray70};
  cursor: pointer;
`

const StyledTotalMileage = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`

const StyledMileageBenefitContent = styled.div`
  padding: 1.6rem 1.6rem 2rem;
`

const StyledMileageBenefitWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`

const StyledMileageBenefitRow = styled.div`
  display: flex;
  justify-content: space-between;
`

const StyledDd = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 0.8rem;
`

const StyledDdBefore = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`
